// extracted by mini-css-extract-plugin
module.exports = {"IconButton":"styles_IconButton__2YMZb"};